import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import $ from "jquery";

import {ROUTES} from "../../../routes";
import {getCommonCoords, getFeatureCoords, getLayerCenter, navFeatureCLick} from "../lookNavigation/lookFunctions";
import {getCurrentLayout} from "../../appLayout";
import {
  setLookActiveCategory,
  setLookActiveFeature,
  setLookDemoPointsClicked,
  setLookOpened, setLookPageOpened
} from "../../../actions/lookFunctions";
import store from "../../../store";
import {LOOK_OPENED_TYPES, LOOK_WALLS} from "../core/constants";
import {IS_LOOK_JOURNEY, IS_PRODUCT_JOURNEY} from "../../../config";
import {addToCart, setCanvasScale, updateCanvasCount} from "../../../actions/actionFunctions";
import {getCartItemObject} from "../../../misc/helpers";
import {
  enableRelatedFeature,
  getCategoryOnlyUrl,
  getFeatureUrl,
  hideFeatureSection
} from "../lookNavigation/lookFunctions2";
import {CABINET_GROUP, COUNTERTOP_GROUP, EDGE_GROUP} from "../../kvComponent/core/constants";

export const doNotZoomPartIds = ["kitchen_floor", "left_wall", "right_wall", "front_wall", "back_wall",
  "split_wall", "left_wall_splitter", "bathroom_floor", "shower_floor", "shower_curb", "shower_pan_combo"];

export const shouldZoomPartId = (partId, isMobile) => {
  if (!partId) {
    return false
  }
  if (!isMobile && (CABINET_GROUP.includes(partId) || COUNTERTOP_GROUP.includes(partId) || EDGE_GROUP.includes(partId))) {
    return false
  }
  return (!doNotZoomPartIds.includes(partId) || (
    partId === "front_wall" && document.kvConfig.visualizerType === "Fireplace"
  ))
}

export const shouldZoomToTheBottom = (partId) => {
  if (!partId) {
    return false
  }
  return partId === "kitchen_floor" || partId === "bathroom_floor" || partId === "shower_pan_combo"
}

export const getCorrectedCenter = (center, scale = 1.75, clickedFeature, imageCanvas, isMobile) => {
  const {activePreset} = store.getState().bathroomVisualizerState;
  if ((clickedFeature.partId === "shower_fixture" || clickedFeature.partId === "crown_molding")
    && imageCanvas.current.pinchZoom.zoomFactor === 1) {
    if (activePreset !== 4) {
      scale = 1.5;
    }
    switch (activePreset) {
      case 3:
        center.y = center.y - 40;
        break;
      case 6:
        center.y = center.y + 40;
        break;
      default:
        break;
    }
    if (!isMobile) {
      $("html, body").animate({scrollTop: 0}, 500);
    }
  } else if (clickedFeature?.getParent?.()?.getParent?.()?.partName === 'Vanity' && !isMobile) {
    if (clickedFeature.partId === "vanity_cabinet") {
      scale = 1.5;
    }
    if (IS_LOOK_JOURNEY) {
      const layout = getCurrentLayout();
      if (clickedFeature.partId === "vanity_mirror") {
        center.y = center.y - 80;
      }
      switch (layout.type) {
        case 18: {
          if (clickedFeature.partId !== "vanity_mirror") {
            center.y = center.y + 320;
          }
          if (clickedFeature.partId === "vanity_cabinet") {
            center.x = center.x - 480;
          } else {
            center.x = center.x - 320;
          }
          break;
        }
        case 19: {
          if (clickedFeature.partId !== "vanity_mirror") {
            if (clickedFeature.partId === "vanity_sink" || clickedFeature.partId === "vanity_faucet") {
              if (clickedFeature.metaData.layerPosition === "R") {
                center.x = center.x - 280
              } else {
                center.x = center.x - 180
              }
            } else {
              center.x = center.x - 180;
            }
          }
          break;
        }
        case 10:
        case 11: {
          center.x = center.x - 420;
          break;
        }
        default:
          break;
      }
    }
  }
  return {scale, center}
}

const WithZoomToFeature = (props) => {

  const {history, children, imageCanvas, isMobile, setLookActiveCategory, setLookActiveFeature, lookOpened,
    setLookOpened, addToCart, qtActiveCategory, setCanvasScale, updateCanvasCount, lookActiveFeature,
    setLookDemoPointsClicked, lookPageOpened, setLookPageOpened, lookActiveCategory, lookCompatabilityAlert} = props;

  /**
   * Checks if list feature is currently active
   * @param partId {string}
   * @param zoomToFeature {featureInterface}
   * @param zoomToPostion {string}
   * @param changeUrl {boolean}
   * @param setActiveFeature {boolean}
   * @param closeOpenedCategory {boolean}
   * @param clickOnFeature {boolean}
   * @returns {featureInterface} clickedFeature
   */
  const zoomToFeatureGroup = (partId,
                              zoomToFeature,
                              zoomToPostion,
                              changeUrl = true,
                              setActiveFeature = true,
                              closeOpenedCategory = true,
                              clickOnFeature = true) => {
    let lookUrl = ROUTES.home;
    let clickedFeature;
    if (partId) {
      const layout = getCurrentLayout();
      const featureGroup = zoomToFeature ? zoomToFeature.getParent() : layout.getFeatureGroupByPartId(partId);
      clickedFeature = zoomToFeature || (featureGroup ? featureGroup.activeFeature : null);
      if (featureGroup && featureGroup.layerPositions && !zoomToFeature) {
        if (zoomToPostion) {
          clickedFeature = featureGroup.getMatchingPositionFeature(zoomToPostion);
          if (clickedFeature && !featureGroup.layerPositions[zoomToPostion]) {
            featureGroup.layerPositions[zoomToPostion] = clickedFeature;
            addToCart([getCartItemObject(clickedFeature, 1, qtActiveCategory)]);
          } else if (!clickedFeature) {
            clickedFeature = featureGroup.activeFeature || featureGroup.activeNotInVisualizerFeature; // show at least something
          }
        } else {
          Object.keys(featureGroup.layerPositions).forEach((position) => {
            if (featureGroup.layerPositions[position] && document.hoveredLayer
              && featureGroup.layerPositions[position].layer.zIndex === document.hoveredLayer.zIndex) {
              clickedFeature = featureGroup.layerPositions[position];
            }
          })
        }
      } else if (featureGroup && !featureGroup.layerPositions && !clickedFeature) {
        clickedFeature = featureGroup.activeFeature || featureGroup.activeNotInVisualizerFeature; // show at least something
      }
      if (clickedFeature) {
        console.log('clickedFeature', clickedFeature);
        if (clickOnFeature) {
          enableRelatedFeature(clickedFeature, addToCart, qtActiveCategory);
          navFeatureCLick(clickedFeature); // is needed for context menu vanity type switch
        }
        // console.log('Coords', clickedFeature.metaData.Coords);
        if (setActiveFeature) {
          setLookActiveFeature(clickedFeature);
        }
        featureGroup.featureBeforeChange = clickedFeature;
        const featureExistInQuotingTool = layout.partIdExistInQtCategory(partId);
        const allowFeatureScreen = featureExistInQuotingTool && !hideFeatureSection(true, partId, clickedFeature, lookCompatabilityAlert);

        if (!IS_PRODUCT_JOURNEY && isMobile && !setActiveFeature) {
          lookUrl = getCategoryOnlyUrl(clickedFeature.partId);
          setLookActiveCategory(clickedFeature.partId);
        } else if (featureExistInQuotingTool && (!IS_PRODUCT_JOURNEY || !lookActiveCategory || closeOpenedCategory)
          && (!IS_PRODUCT_JOURNEY || allowFeatureScreen)) {
          lookUrl = getFeatureUrl(clickedFeature);
        } else {
          lookUrl = getFeatureUrl(clickedFeature, true);
          setLookActiveCategory(clickedFeature.partId);
        }
        // if (!isMobile && imageCanvas.current && imageCanvas.current.setHoveredLayer && event) {
        //   imageCanvas.current.setHoveredLayer(event);
        // }
        const commonCoords = getFeatureCoords(clickedFeature) || getCommonCoords(featureGroup, clickedFeature, imageCanvas.current.canvas);
        const shouldZoomCanvas = imageCanvas.current && imageCanvas.current.pinchZoom && commonCoords && Object.keys(commonCoords).length
          && !clickedFeature.notAvailableInVisualizer && shouldZoomPartId(clickedFeature.partId, isMobile);
        if (shouldZoomCanvas) {
          // const moreZoomFeatureGroups = ["bathtub_fixture"];
          const {center, scale} = getCorrectedCenter(
            getLayerCenter(commonCoords, imageCanvas.current.canvas, isMobile),
            null, clickedFeature, imageCanvas, isMobile
          );
          // const zoomFactor = (moreZoomFeatureGroups.includes(clickedFeature.partId)
          //   && imageCanvas.current.pinchZoom.zoomFactor === 1 ) ? 3 : null // if null - it will be set in zoom to center func
          imageCanvas.current.pinchZoom.zoomToCenter(center, scale, false, allowFeatureScreen);
          setCanvasScale(imageCanvas.current.pinchZoom.options.tapZoomFactor);
        } else if (shouldZoomToTheBottom(clickedFeature.partId)) {
          $("html, body").animate({scrollTop: document.body.scrollHeight}, 500);
        }
        if (!lookOpened) {
          setLookOpened(LOOK_OPENED_TYPES.featureZoom);
          setLookDemoPointsClicked(true);
        }
        if (IS_PRODUCT_JOURNEY && lookPageOpened) {
          setLookPageOpened("");
        }
      }
    }
    if (changeUrl) {
      history.push(lookUrl);
    }
    return clickedFeature
  }

  const zoomToFeatureGroupByFeature = (zoomFeature) => {
    const featureGroup = zoomFeature.getParent();
    const isEmpty = (!zoomFeature && position) || (featureGroup && featureGroup.disabled);
    if (isEmpty) {
      if (!lookActiveFeature && position) {
        zoomFeature = featureGroup.getMatchingPositionFeature(position);
        if (zoomFeature) {
          featureGroup.layerPositions[position] = zoomFeature;
        }
      }
      if (zoomFeature) {
        featureGroup.activeFeature = zoomFeature;
      }
      console.log("zoomFeature featureGroup", zoomFeature, featureGroup);
    }
    const layout = getCurrentLayout();
    if (zoomFeature) {
      if (!lookActiveFeature) {
        const parent = zoomFeature.getParent();
        parent.featureBeforeChange = zoomFeature;
      }
      setLookActiveFeature(zoomFeature);
      navFeatureCLick(zoomFeature);
      enableRelatedFeature(zoomFeature, addToCart, qtActiveCategory);

      if (isMobile) {
        // const closeOnly = zoomFeature && !layout.partIdExistInQtCategory(zoomFeature.partId) && !LOOK_WALLS.includes(zoomFeature.partId);
        const closeOnly = zoomFeature && !layout.partIdExistInQtCategory(zoomFeature.partId);
        if (closeOnly) {
          //history.push(getFeatureUrl(zoomFeature, true));
        } else {
          setLookActiveCategory("");
          //history.push(getFeatureUrl(zoomFeature)); // always go to feature screen on mobile
        }
      } else {
        // history.push(getFeatureUrl(zoomFeature, !!lookActiveCategory))
      }

      updateCanvasCount();
      if (imageCanvas && imageCanvas.current && imageCanvas.current.pinchZoom && !LOOK_WALLS.includes(zoomFeature.partId)) {
        const commonCoords = getFeatureCoords(zoomFeature) || getCommonCoords(featureGroup || zoomFeature.getParent(), zoomFeature, imageCanvas.current.canvas);
        const center = getLayerCenter(commonCoords, imageCanvas.current.canvas, isMobile);
        const scale = imageCanvas.current.pinchZoom.options.tapZoomFactor;
        imageCanvas.current.pinchZoom.zoomToCenter(center, scale, true, layout.partIdExistInQtCategory(zoomFeature.partId));
        setCanvasScale(scale)
      }
    }
  }

  return children(zoomToFeatureGroup, zoomToFeatureGroupByFeature)
};

const mapStateToProps = (store) => {
  const {lookOpened, lookActiveFeature, lookActiveCategory, lookCompatabilityAlert} = store.lookState;
  const {isMobile} = store.serverState;
  const {qtActiveCategory} = store.qtState;
  return {
    lookOpened,
    lookActiveFeature,
    isMobile,
    qtActiveCategory,
    lookActiveCategory,
    lookCompatabilityAlert,
  }
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookActiveFeature,
  setLookOpened,
  addToCart,
  setCanvasScale,
  updateCanvasCount,
  setLookDemoPointsClicked,
  setLookPageOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithZoomToFeature)
)
